<template>
  <div
    class="m-confirm"
    :class="[theme]"
    :style="{ '--m-confirm-w': width, '--m-confirm-h': height }"
  >
    <div class="m-confirm__content">
      <slot>
        <div class="m-confirm__content-title">{{ title }}</div>
        <div class="m-confirm__content-msg">{{ content }}</div>
      </slot>
      <div class="m-confirm__content-buttons">
        <ElButton
          v-for="btn in btns"
          :key="btn.text"
          @click="btn.onClick($event, callback, handleClose)"
        >
          {{ btn.text }}
        </ElButton>
      </div>
    </div>
    <div class="m-confirm__bg"></div>
  </div>
</template>

<script>
import { isFunction } from '@/utils/is';
export default {
  props: {
    title: String,
    content: String,
    width: {
      type: String,
      default: '402px'
    },
    height: {
      type: String,
      default: '246px'
    },
    callback: Function,
    btns: {
      type: Array,
      default: () => [
        {
          text: '确认',
          onClick: (event, cb, done) => {
            if (isFunction(cb)) {
              cb('cancel', done, event);
            } else {
              done();
            }
          }
        },
        {
          text: '取消',
          onClick: (event, cb, done) => {
            if (isFunction(cb)) {
              cb('cancel', done, event);
            } else {
              done();
            }
          }
        }
      ]
    },
    theme: String,
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    }
  },
  mounted() {
    this.container.appendChild(this.$el);
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.m-confirm {
  // --basic-size: 18px;
  // --m-confirm_btn-border: 2px solid #00cdb8;
  // --m-confirm_btn-color: #fff;
  // --m-confirm_btn-bg: #0a323f;
  // --m-confirm_content-color: #fff;

  width: var(--m-confirm-w);
  height: var(--m-confirm-h);
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 99;
  transform: translate(-50%, -50%);

  font-size: var(--basic-size);

  &__content {
    width: 90.5%;
    height: 90%;
    position: absolute;
    left: 5%;
    top: 5.2%;
    z-index: 2;

    color: var(--m-confirm_content-color);

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    &-title {
      font-size: 1em;
      min-height: 1em;
    }

    &-msg {
      font-size: 1em;
      letter-spacing: 2px;
    }

    &-buttons {
      align-self: center;
      margin-bottom: 9%;
      display: flex;
      justify-content: space-around;
      width: 88%;

      .el-button {
        border: var(--m-confirm_btn-border);
        transform: skew(-4deg, 0);
        color: var(--m-confirm_btn-color);
        background: var(--m-confirm_btn-bg);
        width: 4.8em;
        height: 1.8em;
        line-height: 0;
        padding: 0;
        font-size: 1em;

        span {
          letter-spacing: 0.4em;
          position: relative;
          left: 0.2em;
        }

        + .el-button {
          margin-left: 0;
        }

        &:hover {
          filter: brightness(1.2);
        }
      }
    }
  }

  &__bg {
    width: 100%;
    height: 100%;

    position: absolute;
    left: 0;
    top: 0;

    background-image: url(~@/assets/image/components/confirm-bg.png);
    background-size: 100% 100%;
  }
}
</style>
